import Box from "@mui/material/Box";
import { Component } from "react";
import ProfileBottomNav from "../../../components/ProfileBottomNav";
import ProfileHeader from "../../../components/ProfileHeader";
import RecoverPasswordFourthInner from "../../public/recoverPassword/recoverPasswordFourth/RecoverPasswordFourthInner";

type Props = {};

type State = {
}

export default class ChangedPassword extends Component<Props, State> {

  componentDidMount() {
    document.body.classList.add("grey-background");
  }

  componentWillUnmount() {
    window.location.reload();
    document.body.classList.remove("grey-background");
  }

  render() {
    return (
      <Box>
        <ProfileHeader title='Nueva contraseña'></ProfileHeader>
        <RecoverPasswordFourthInner redirect='/' acceptButtonText='Continuar'></RecoverPasswordFourthInner>
        <ProfileBottomNav></ProfileBottomNav>
      </Box>
    );
  }

}